// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/tenant_failover.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { TenantFailover } from "../v2/tenant_failover_pb.js";
import { file_agentplatform_v2_tenant_failover } from "../v2/tenant_failover_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/tenant_failover.proto.
 */
export const file_agentplatform_httpv2_tenant_failover: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v2_tenant_failover, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateTenantFailoverRequest
 */
export type CreateTenantFailoverRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateTenantFailoverRequest"> & {
  /**
   * 备用模型池（有序，从左到右依次降级切换）/ Backup model list (ordered)
   * @gotags: json:"backup_models"
   *
   * @generated from field: repeated string backup_models = 1 [json_name = "backup_models"];
   */
  backupModels: string[];

  /**
   * 是否启用（可选，缺省 true）/ Enabled flag (optional, default true)
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateTenantFailoverRequest.
 * Use `create(CreateTenantFailoverRequestSchema)` to create a new message.
 */
export const CreateTenantFailoverRequestSchema: GenMessage<CreateTenantFailoverRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateTenantFailoverResponse
 */
export type CreateTenantFailoverResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateTenantFailoverResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TenantFailover data = 4;
   */
  data?: TenantFailover | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateTenantFailoverResponse.
 * Use `create(CreateTenantFailoverResponseSchema)` to create a new message.
 */
export const CreateTenantFailoverResponseSchema: GenMessage<CreateTenantFailoverResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetTenantFailoverRequest
 */
export type GetTenantFailoverRequest = Message<"infinigence.infini.agentplatform.httpv2.GetTenantFailoverRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetTenantFailoverRequest.
 * Use `create(GetTenantFailoverRequestSchema)` to create a new message.
 */
export const GetTenantFailoverRequestSchema: GenMessage<GetTenantFailoverRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetTenantFailoverResponse
 */
export type GetTenantFailoverResponse = Message<"infinigence.infini.agentplatform.httpv2.GetTenantFailoverResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TenantFailover data = 4;
   */
  data?: TenantFailover | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetTenantFailoverResponse.
 * Use `create(GetTenantFailoverResponseSchema)` to create a new message.
 */
export const GetTenantFailoverResponseSchema: GenMessage<GetTenantFailoverResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverRequest
 */
export type UpdateTenantFailoverRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 备用模型池（有序；提供则整体覆盖，不修改时留空）/ Backup model list (ordered; replaces whole list, leave empty to keep)
   * @gotags: json:"backup_models,omitempty"
   *
   * @generated from field: repeated string backup_models = 2 [json_name = "backup_models"];
   */
  backupModels: string[];

  /**
   * 是否启用（不修改时留空）/ Enabled flag (leave unset to keep current)
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverRequest.
 * Use `create(UpdateTenantFailoverRequestSchema)` to create a new message.
 */
export const UpdateTenantFailoverRequestSchema: GenMessage<UpdateTenantFailoverRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverResponse
 */
export type UpdateTenantFailoverResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateTenantFailoverResponse.
 * Use `create(UpdateTenantFailoverResponseSchema)` to create a new message.
 */
export const UpdateTenantFailoverResponseSchema: GenMessage<UpdateTenantFailoverResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverRequest
 */
export type DeleteTenantFailoverRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverRequest.
 * Use `create(DeleteTenantFailoverRequestSchema)` to create a new message.
 */
export const DeleteTenantFailoverRequestSchema: GenMessage<DeleteTenantFailoverRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 6);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverResponse
 */
export type DeleteTenantFailoverResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteTenantFailoverResponse.
 * Use `create(DeleteTenantFailoverResponseSchema)` to create a new message.
 */
export const DeleteTenantFailoverResponseSchema: GenMessage<DeleteTenantFailoverResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListTenantFailoversResponse
 */
export type ListTenantFailoversResponse = Message<"infinigence.infini.agentplatform.httpv2.ListTenantFailoversResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListTenantFailoversData data = 4;
   */
  data?: ListTenantFailoversData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListTenantFailoversResponse.
 * Use `create(ListTenantFailoversResponseSchema)` to create a new message.
 */
export const ListTenantFailoversResponseSchema: GenMessage<ListTenantFailoversResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 8);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListTenantFailoversData
 */
export type ListTenantFailoversData = Message<"infinigence.infini.agentplatform.httpv2.ListTenantFailoversData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.TenantFailover items = 1;
   */
  items: TenantFailover[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListTenantFailoversData.
 * Use `create(ListTenantFailoversDataSchema)` to create a new message.
 */
export const ListTenantFailoversDataSchema: GenMessage<ListTenantFailoversData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_tenant_failover, 9);

/**
 * TenantFailoverHTTPV2Service 租户级模型 failover 备用池 HTTP V2 服务 / Tenant failover HTTP V2 service
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service
 */
export const TenantFailoverHTTPV2Service: GenService<{
  /**
   * 创建租户级 failover 备用池 / Create tenant failover pool
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service.CreateTenantFailover
   */
  createTenantFailover: {
    methodKind: "unary";
    input: typeof CreateTenantFailoverRequestSchema;
    output: typeof CreateTenantFailoverResponseSchema;
  },
  /**
   * 获取租户级 failover 备用池 / Get tenant failover pool
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service.GetTenantFailover
   */
  getTenantFailover: {
    methodKind: "unary";
    input: typeof GetTenantFailoverRequestSchema;
    output: typeof GetTenantFailoverResponseSchema;
  },
  /**
   * 更新租户级 failover 备用池 / Update tenant failover pool
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service.UpdateTenantFailover
   */
  updateTenantFailover: {
    methodKind: "unary";
    input: typeof UpdateTenantFailoverRequestSchema;
    output: typeof UpdateTenantFailoverResponseSchema;
  },
  /**
   * 删除租户级 failover 备用池 / Delete tenant failover pool
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service.DeleteTenantFailover
   */
  deleteTenantFailover: {
    methodKind: "unary";
    input: typeof DeleteTenantFailoverRequestSchema;
    output: typeof DeleteTenantFailoverResponseSchema;
  },
  /**
   * 列出租户级 failover 备用池 / List tenant failover pools
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.TenantFailoverHTTPV2Service.ListTenantFailovers
   */
  listTenantFailovers: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListTenantFailoversResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_tenant_failover, 0);

